import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthorizationGuard } from './guards/authorization.guard';
import { NavigationGuard } from './guards/navigation.guard';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home-page/home/home.component';
import { DealWizardComponent } from './components/deal-wizard/deal-wizard.component';
import { DealsPageComponent } from './components/deals/deals-page/deals-page.component';
import { ServiceItemsPageComponent } from './components/service-items/service-items-page/service-items-page.component';
import { ParametersPageComponent } from './components/parameters/parameters-page/parameters-page.component';
import { TermsPageComponent } from './components/terms/terms-page/terms-page.component';
import { UsersPageComponent } from './components/users/users-page/users-page.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { TermsOfUsePageComponent } from './components/terms-of-use/terms-of-use-page/terms-of-use-page.component';
import { PermissionErrorPageComponent } from './components/permission-error-page/permission-error-page.component';

const routes: Routes = [
    { path: 'login', component: LoginComponent },
    {
        path: 'home', component: HomeComponent, canActivate: [AuthorizationGuard], children: [
            
            { path: 'deal-wizard/:id/:key/:pay', component: DealWizardComponent, canActivate: [AuthorizationGuard], canDeactivate: [NavigationGuard] },
            
            { path: 'deals', component: DealsPageComponent, canActivate: [AuthorizationGuard] },
            { path: 'parameters', component: ParametersPageComponent, canActivate: [AuthorizationGuard] },
            { path: 'service-items', component: ServiceItemsPageComponent, canActivate: [AuthorizationGuard] },
            { path: 'terms', component: TermsPageComponent, canActivate: [AuthorizationGuard] },
            { path: 'terms-of-use', component: TermsOfUsePageComponent, canActivate: [AuthorizationGuard] },
            { path: 'users', component: UsersPageComponent, canActivate: [AuthorizationGuard] },
            { path: 'error', component: ErrorPageComponent/*, canActivate: [AuthorizationGuard]*/ },
            { path: 'perm-error/:message', component: PermissionErrorPageComponent/*, canActivate: [AuthorizationGuard]*/ },
            { path: '', redirectTo: 'deals', pathMatch: 'full' /*, canActivate: [AuthorizationGuard]*/ },
        ]
    },
    //{ path: 'error', component: ErrorPageComponent/*, canActivate: [AuthorizationGuard]*/ },
    { path: '**', redirectTo: 'home'/*, canActivate: [AuthorizationGuard]*/}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts